export default __webpack_public_path__ + "static/media/square-x.ba9d0345.svg";